import is from '@sindresorhus/is';
/**
 * @name compose
 * @description This function compose several unary function into one
 * @param {UnaryFunction[]} functions All the functions to compose
 * @returns {UnaryFunction} The composed function
 *
 * @example
 * import {compose} from 'gso-utilities';
 * const increment = x => x + 1;
 * const composed = compose(increment,increment); // increment(increment(x))
 * const composedResult = composed(1);
 * console.log(composedResult); // 3
 */
function compose(...functions) {
    return function composed(result) {
        // Copy the array of functions
        const stack = [...functions];
        while (stack.length > 0) {
            // Take the last function off the end of the list and execute it
            const lastFunction = stack.pop();
            if (is.function_(lastFunction)) {
                result = lastFunction(result);
            }
        }
        return result;
    };
}
export { compose };
//# sourceMappingURL=compose.js.map